import React, { Fragment, useCallback, useContext, useState } from "react";
import { Fade } from "react-awesome-reveal";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import "rsuite/dist/rsuite.min.css";

// import useGoogleMapsScript from "../components/useGoogleMapsScript";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import LoaderInternal from "../../LoaderInternal";
import {
  fetchCruiseDetails,
  setSelectedCruiseCode,
} from "../../data/groupBooking/cruiseDetailsSlice";
// import { BookingForm } from "../../components/BookingForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
// import FilterLeftSide from "../../components/FilterLeftSide";
import { BookingFormListing } from "../../components/BookingFormListing";
import { fetchCruiseListBooking } from "../../data/groupBooking/cruiseListSlice";
import { BrandColorContext } from "../../App";
// import { Tooltip } from "react-bootstrap";
import Description from "../../components/Description";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

const ListingCruises = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isSmallScreen = useMediaQuery("(max-width:1023px)");

  const { cruisesListBooking, loadingCruisesList, errorCruisesList } =
    useSelector((state) => state.cruisesListBooking);
  const language = useSelector((state) => state.language.language) || "en";
  const [selectedItinerary, setSelectedItinerary] = useState([]); // State to hold the selected itinerary
  const [PageNumber, setPageNumber] = useState(1);
  const [CruiseLocationId, setCruiseLocationId] = useState([]); // Updated to handle multiple IDs
  const [CruiseTypeIds, setCruiseTypeIds] = useState([]); // Updated to handle multiple IDs
  const [CruiseBrandIds, setCruiseBrandIds] = useState([]); // Updated to handle multiple IDs
  const [CruiseRatingName, setCruiseRatingName] = useState([]); // Updated to handle multiple IDs
  const [SearchInput, setSearchInput] = useState(null); // Updated to handle multiple IDs
  const handlePagination = (index) => {
    setPageNumber(index);
    setTimeout(() => {
      document.getElementById("top").scrollIntoView({ behavior: "smooth" });
    }, 0); // Delay to ensure the element is rendered
  };
  const [isActiveMapFilter, setIsActiveMapFilter] = useState(false);
  const brandColor = useContext(BrandColorContext);
  const chainCode = queryParams.get("chainCode");
  const operationDate = queryParams.get("operationDate");
  const durationDay = queryParams.get("durationDay");
  const startDestId = queryParams.get("startDestId");
  const endDestId = queryParams.get("endDestId");
  const numCabins = queryParams.get("numCabins");
  const [roomData, setRoomData] = useState([
    { adultNumber: 1, childNumber: 0, childAges: [] },
  ]);
  useEffect(() => {
    // This effect handles fetching data on initial load or page refresh.
    // It runs only if the URL parameters change.
    const cabins = [];

    for (let i = 1; i <= numCabins; i++) {
      const adults = parseInt(queryParams.get(`adults_room_${i}`), 10) || 2;
      const children = parseInt(queryParams.get(`children_room_${i}`), 10) || 0;
      const childrenAgesParam = queryParams.get(`childAges_room_${i}`);
      const childrenAges =
        childrenAgesParam &&
        childrenAgesParam !== "undefined" &&
        childrenAgesParam !== "null"
          ? childrenAgesParam?.split(",").filter(Boolean).map(Number)
          : cruisesListBooking?.request?.cabins[i - 1]?.childrenAges || [0];
      cabins.push({ cabinNumber: i, adults, children, childrenAges });
    }
    const fetchData = () => {
      const payload = {
        operationDate,
        durationDay,
        startDestId,
        endDestId,
        numCabins,
        cabins,
      };
      dispatch(fetchCruiseListBooking({ payload, chainCode }));
    };

    // Only fetch if data is not already present from the previous step.
    // This primarily triggers on page refresh.
    if (cruisesListBooking?.length === 0) {
      fetchData();
    }
    setRoomData(cabins);
  }, [dispatch, location.search, cruisesListBooking?.length]);

  const handleCruiseClick = useCallback(
    async (cruiseId, itineraryId) => {
      const payload = {
        // chainCode,
        cruiseId,
        operationDate: cruisesListBooking.request?.operationDate,
        itineraryId: itineraryId,
        numCabins: cruisesListBooking.request?.numCabins,
        cabins: cruisesListBooking.request.cabins.map((room, index) => ({
          cabinNumber: index + 1,
          adults: room.adults,
          children: room.children,
          childrenAges: room.children > 0 ? room.childrenAges : [0],
        })),
      }; // Create query string from payload
      const queryStringParams = {
        chainCode,
        cruiseId: payload.cruiseId,
        itineraryId: payload.itineraryId,
        operationDate: payload.operationDate,
        numCabins: payload.numCabins,
        durationDay,
        startDestId,
        endDestId,
      };

      roomData?.forEach((room, index) => {
        queryStringParams[`adults_room_${index + 1}`] = room.adults;
        queryStringParams[`children_room_${index + 1}`] = room.children;
        queryStringParams[`childAges_room_${index + 1}`] =
          room?.childAges?.join(",");
      });

      dispatch(setSelectedCruiseCode(cruiseId));
      const queryString = new URLSearchParams(queryStringParams).toString();
      try {
        const resultAction = await dispatch(
          fetchCruiseDetails({ payload, chainCode, language })
        );
        if (fetchCruiseDetails.fulfilled.match(resultAction)) {
          navigate(`/cruises-details?lang=${language}&${queryString}`);
        } else {
          throw new Error(resultAction.error.message);
        }
      } catch (err) {
        alert(err.message || t("common.errorOccurredWhileSearching"));
      }
    },
    [chainCode, dispatch, navigate, roomData]
  );
  // useEffect(() => {
  //   const autoNavigate = async () => {
  //     if (
  //       !loadingCruisesList &&
  //       cruisesListBooking?.cruises?.length === 1 &&
  //       cruisesListBooking?.cruises[0]?.cruiseID
  //     ) {
  //       const cruise = cruisesListBooking.cruises[0];
  //       try {
  //         await handleCruiseClick(
  //           cruise.cruiseID,
  //           cruise.itinerary.itineraryID
  //         );
  //       } catch (err) {
  //         console.error("Auto-navigation failed:", err);

  //       }
  //     }
  //   };

  //   autoNavigate();
  // }, [
  //   cruisesListBooking,
  //   loadingCruisesList,
  //   handleCruiseClick,
  //   dispatch,
  //   navigate,
  // ]);
  const [itineraryName, setItineraryName] = useState("");
  const handleViewItinerary = (cruiseID, name) => {
    // handleCruiseClick(operationID);
    const selectedCruise = cruisesListBooking?.cruises.find(
      (cruise) => cruise.cruiseID === cruiseID
    );

    setSelectedItinerary(selectedCruise?.itinerary);
    setItineraryName(name);
    setIsActiveMapFilter(true);
  };
  const [activeFaq, setActiveFaq] = useState(null);

  // Function to toggle accordion item
  const toggleAccordion = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <Fragment>
      <Helmet>
        <title>{t("common.listingCruises")}</title>

        <style type="text/css">
          {`
            .header .header-menu .menu li a{
            color:#051036;
            }
            .header .header-menu .menu .subnav>li>a {
            color:#051036 !important;
            }
            .is-sticky.bg-dark-1{
            background-color:#fff !important;
            }
            // .is-sticky .menu li a{
            // color:#fff !important;
            // }
            .ratio-15\\:9::before{
            padding-bottom:0 !important;}
              .description {import { Tooltip } from '@mui/material';

    overflow: hidden;
    transition: max-height 0.3s ease;
  }
  .collapsed {
   display: -webkit-box;
   -webkit-line-clamp: 2;
   -webkit-box-orient: vertical;
   overflow: hidden;
   text-overflow: ellipsis;  
  }
  .expanded {
   display: block;
   -webkit-line-clamp: unset;
   -webkit-box-orient: unset;
   overflow: unset;
   text-overflow:unset; 
  }
   .rs-picker-date>.rs-input-group.rs-input-group-inside .rs-input{
   padding-left:0}
            `}
        </style>
      </Helmet>
      {/*banner */}

      <section className="masthead pt-90 pb-0 bg-light-2" id="top">
        {" "}
        <div className="container pb-20">
          <div className="row pt-90">
            <div className="col-12">
              <div className="text-center water-text">
                <Fade
                  className="x"
                  direction="down"
                  duration={1000}
                  delay={0}
                  damping={0.1}
                  cascade
                >
                  <h1
                    style={{ textTransform: "capitalize" }}
                    className="text-40 lg:text-40 md:text-30 text-white is-in-view  "
                  >
                    {t("common.sailIntoSerenity", {
                      nights: cruisesListBooking?.request?.durationDay,
                    })}
                  </h1>
                </Fade>
              </div>
            </div>
          </div>
        </div>{" "}
        <div className="row d-flex items-center  mt-0  ">
          <div className="  mt-20 py-40 bg-light-2 border-top-light">
            <div className="container d-flex justify-content-between m-auto px-1    y-gap-30 items-center ">
              <div className="col-auto pe-1">
                <div className="d-flex items-center">
                  <div className="size-40 rounded-full flex-center bg-blue-1">
                    <span className=" text-16 text-white">1</span>
                  </div>
                  <div className="text-18 text-blue-1 fw-500 ml-10">
                    {t("booking.chooseCruise")}
                  </div>
                </div>
              </div>{" "}
              <div className="col px-1">
                <div className="w-full h-1 border-blue-1 bg-border"></div>
              </div>
              <div className="col-auto  px-1">
                <div className="d-flex items-center">
                  <div className="size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500">
                    2
                  </div>
                  <div className="text-18 fw-500 ml-10">
                    {" "}
                    {t("booking.chooseCabin")}{" "}
                  </div>
                </div>
              </div>
              <div className="col px-1">
                <div className="w-full h-1 bg-border"></div>
              </div>
              <Fragment>
                <div className="col-auto px-1">
                  <div className="d-flex items-center">
                    <div className="size-40 rounded-full ">
                      <div className="size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500">
                        3
                      </div>
                    </div>
                    <div className="text-18 fw-500 ml-10">
                      {t("booking.addExtra")}
                    </div>
                  </div>
                </div>

                <div className="col px-1">
                  <div className="w-full h-1 bg-border"></div>
                </div>
              </Fragment>
              <div className="col-auto px-1">
                <div className="d-flex items-center">
                  <div className="size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500">
                    4
                  </div>
                  <div className="text-18 fw-500 ml-10">
                    {t("booking.checkout")}{" "}
                  </div>
                </div>
              </div>
              <div className="col px-1">
                <div className="w-full h-1 bg-border"></div>
              </div>
              <div className="col-auto px-1">
                <div className="d-flex items-center">
                  <div className="size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500">
                    5
                  </div>
                  <div className="text-18 fw-500 ml-10">
                    {t("booking.bookingCompleted")}{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* booking engine  */}
      {/* <div className="py-20 bg-light-2">
        <div className="container">
         
          <BookingFormListing
            CruiseLocationId={CruiseLocationId}
            CruiseTypeIds={CruiseTypeIds}
            CruiseBrandIds={CruiseBrandIds}
            CruiseRatingName={CruiseRatingName}
            SearchInput={SearchInput}
          />
        </div>
      </div> */}
      <section className="layout-pt-md layout-pb-lg">
        <div className="container">
          <div className="row justify-content-between y-gap-30">
            <div
              className="col-lg-3 h-100"
              style={{ boxShadow: !loadingCruisesList && "0 0 2px #ccc" }}
            >
              {" "}
              <BookingFormListing
              // CruiseLocationId={CruiseLocationId}
              // CruiseTypeIds={CruiseTypeIds}
              // CruiseBrandIds={CruiseBrandIds}
              // CruiseRatingName={CruiseRatingName}
              // SearchInput={SearchInput}
              />
              {/* <FilterLeftSide
                cruisesListBooking={cruisesListBooking}
                setCruiseTypeIds={setCruiseTypeIds}
                setCruiseLocationId={setCruiseLocationId}
                setCruiseBrandIds={setCruiseBrandIds}
                setCruiseRatingName={setCruiseRatingName}
                setSearchInput={setSearchInput}
              /> */}
            </div>

            <div className="col-lg-9">
              <div className="row y-gap-10 items-center justify-between">
                <div className="col-auto">
                  <div className="text-18">
                    <span className="fw-500">
                      {cruisesListBooking?.cruisesGeneralData?.cruisesNum || 0}{" "}
                      {cruisesListBooking?.cruisesGeneralData?.cruisesNum > 1
                        ? t("common.cruises")
                        : t("common.cruise")}{" "}
                      {t("common.found")}
                    </span>
                  </div>
                </div>
              </div>

              {/* cruise Card  */}
              {loadingCruisesList ? (
                <LoaderInternal />
              ) : (
                <div className="row y-gap-30 mt-10 ">
                  <Fade
                    cascade
                    triggerOnce
                    duration={1000}
                    delay={0}
                    direction="right"
                    damping={0.1}
                  >
                    {cruisesListBooking?.cruises?.length > 0 ? (
                      cruisesListBooking?.cruises?.map((cruise, index) => (
                        <div className="col-12" key={cruise.cruiseID}>
                          <div className="border-top-light py-20">
                            <div className="row align-content-center  x-gap-20 y-gap-20">
                              <div className="col-md-auto cruiseCard">
                                {/* Gallery  */}{" "}
                                {/* <div
                                  className="f54c1d70e0"
                                  data-testid="gallery-ribbon"
                                >
                                  <div className="aaa3a3be2e">{t("common.topRated")}</div>
                                 
                                </div> */}
                                <div
                                  className="cardImage ratio ratio-1:1 w-250 md:w-1/1 rounded-4"
                                  style={{ height: "200px" }}
                                >
                                  <div
                                    className="cardImage__content"
                                    style={{ height: "100%" }}
                                  >
                                    <Swiper
                                      style={{ height: "100%" }}
                                      modules={[
                                        Pagination,
                                        Navigation,
                                        Autoplay,
                                      ]}
                                      autoplay={{
                                        delay: 3000,
                                        loop: false,
                                        delayTimeout: 1000,
                                        disableOnInteraction: false, // Continue autoplay after user interactions
                                      }}
                                      spaceBetween={50}
                                      slidesPerView={1}
                                      navigation={{
                                        prevEl: `.js-prev-${index}`, // Custom previous button class
                                        nextEl: `.js-next-${index}`, // Custom next button class
                                      }} // Enable custom navigation
                                      pagination={{
                                        clickable: true,
                                        el: ".js-pagination", // Target custom pagination class
                                        renderBullet: (index, className) => {
                                          return `<div className="pagination__item ${className}" tabIndex="0" role="button" aria-label="${t(
                                            "common.goToSlide"
                                          )} ${index + 1}"></div>`;
                                        },
                                      }}
                                    >
                                      {cruise.cruisePhotos?.length > 0 ? (
                                        cruise.cruisePhotos?.map(
                                          (image, index) => (
                                            <SwiperSlide
                                              key={index}
                                              style={{ height: "100%" }}
                                            >
                                              <img
                                                style={{ height: "100%" }}
                                                className="col-12"
                                                src={image}
                                                alt={cruise.cruiseName}
                                              />
                                            </SwiperSlide>
                                          )
                                        )
                                      ) : (
                                        <SwiperSlide>
                                          <div className="no-image-found d-flex justify-center  ">
                                            <p className="text-danger">
                                              {t("common.noImageFound")}
                                            </p>
                                          </div>
                                        </SwiperSlide>
                                      )}
                                    </Swiper>
                                    {/* Custom Pagination Element */}
                                    <div className="cardImage-slider__pagination js-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>

                                    {/* Custom Navigation Buttons */}
                                    {cruise.cruisePhotos?.length > 1 ? (
                                      <Fragment>
                                        <div className="cardImage-slider__nav -prev">
                                          <button
                                            className={`button -blue-1 bg-white size-30 rounded-full shadow-2 js-prev-${index}`}
                                            tabIndex="0"
                                            aria-label={t(
                                              "common.previousSlide"
                                            )}
                                          >
                                            <i className="icon-chevron-left text-10"></i>
                                          </button>
                                        </div>
                                        <div className="cardImage-slider__nav -next">
                                          <button
                                            className={`button -blue-1 bg-white size-30 rounded-full shadow-2 js-next-${index}`}
                                            tabIndex="0"
                                            aria-label={t("common.nextSlide")}
                                          >
                                            <i className="icon-chevron-right text-10"></i>
                                          </button>
                                        </div>
                                      </Fragment>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md">
                                <h3 className="text-18 lh-16 fw-500">
                                  {cruise.cruiseName}
                                </h3>{" "}
                                <span className="text-15 text-secondary lh-12 fw-500">
                                  ({cruise.locationName})
                                </span>
                                <div
                                  className="d-inline-block ml-10"
                                  dangerouslySetInnerHTML={{
                                    __html: cruise.ratingStarCode,
                                  }}
                                />
                                <div className="row x-gap-10 y-gap-10 items-center pt-2">
                                  <div className="col-auto">
                                    <p className="text-14">
                                      {cruise.itinerary.itineraryName}
                                    </p>
                                  </div>

                                  <div className="col-auto">
                                    <button
                                      onClick={() =>
                                        handleViewItinerary(
                                          cruise.cruiseID,
                                          cruise.itinerary.itineraryName
                                        )
                                      }
                                      className="d-block text-14 text-blue-1 underline"
                                    >
                                      {t("common.viewItinerary")}{" "}
                                    </button>
                                  </div>
                                </div>
                                <Description htmlContent={cruise.description} />
                                {cruise.cruiseFreeCancelation && (
                                  <div className="text-14 text-green-2 lh-15 mt-10">
                                    <div className="fw-500">
                                      {t("common.freeCancellation")}{" "}
                                    </div>
                                    <div className="">
                                      {t("common.youCanCancelAfter")}{" "}
                                      {cruise.cruiseFreeCancelation}.{" "}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-md-auto text-right md:text-left">
                                <div className="row x-gap-10 y-gap-10 justify-end items-center md:justify-start">
                                  <div className="col-auto">
                                    <div className="text-14  lh-14 fw-500">
                                      {cruise.companyName}{" "}
                                    </div>
                                    <div className="text-14 lh-14 text-light-1">
                                      {cruise.deckNum}{" "}
                                      {cruise.deckNum > 1
                                        ? t("common.decks")
                                        : t("common.decks").slice(0, -1)}{" "}
                                    </div>
                                  </div>
                                </div>

                                <div className="">
                                  <div className="text-14 text-light-1 mt-30 md:mt-30">
                                    {/* {cruise.durationNameSys},  */}
                                    {
                                      cruisesListBooking.request?.cabins[0]
                                        .adults
                                    }{" "}
                                    {cruisesListBooking.request?.cabins[0]
                                      .adults > 1
                                      ? t("common.adults")
                                      : t("common.adults").slice(0, -1)}
                                  </div>
                                  <div className="text-20  lh-12 fw-600 mt-5">
                                    {cruise.currencyCode || "$"}
                                    {cruise.priceStartsFrom}
                                  </div>
                                  {/* <div className="text-14 text-light-1 mt-5">
                                    +US$828 taxes and charges{" "}
                                  </div> */}

                                  <button
                                    type="button"
                                    className="button -md -dark-1 bg-blue-1 text-white mt-15"
                                    onClick={() =>
                                      handleCruiseClick(
                                        cruise.cruiseID,
                                        cruise.itinerary.itineraryID
                                      )
                                    }
                                  >
                                    {t("common.seeAvailability")}{" "}
                                    <div className="icon-arrow-top-right ml-15"></div>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-image-found d-flex justify-center  ">
                        <p className="text-danger my-5">
                          {t("common.noCruisesAvailable")}
                        </p>
                      </div>
                    )}
                  </Fade>
                </div>
              )}
              {/* <div className="border-top-light   pt-30">
                <div className="row x-gap-10 y-gap-20 justify-between md:justify-center">
                  <div className="row x-gap-20 justify-content-between y-gap-20 items-center ">
                    <div className="col-auto ">
                      <button
                        onClick={() =>
                          PageNumber > 1 && handlePagination(PageNumber - 1)
                        }
                        disabled={PageNumber <= 1 ? true : false}
                        className="button -blue-1 size-40 rounded-full border-light"
                      >
                        <i className="icon-chevron-left text-12"></i>
                      </button>
                    </div>

                    <div className="col-auto d-flex">
                      {" "}
                      <div className="col-auto">
                        <button
                          className={`size-40 flex-center rounded-full bg-blue-1 text-white  `}
                          style={{ boxShadow: "0 0 2px #fcfcfc" }}
                          // onClick={() => handlePagination(index + 1)}
                        >
                          {cruisesListBooking?.pageIndex}
                        </button>
                      </div>
                      {cruisesListBooking?.totalPages > 1 ? (
                        <Fragment>
                          <div className="col-auto">
                            <div className="size-40 flex-center rounded-full">
                              ...{" "}
                            </div>
                          </div>
                          <div className="col-auto">
                            <div className="size-40 flex-center rounded-full">
                              {cruisesListBooking?.totalPages}
                            </div>
                          </div>
                        </Fragment>
                      ) : null}
                    </div>

                    <div className="col-auto ">
                      <button
                        onClick={() =>
                          cruisesListBooking?.totalPages > PageNumber &&
                          handlePagination(PageNumber + 1)
                        }
                        disabled={
                          PageNumber >= cruisesListBooking?.totalPages
                            ? true
                            : false
                        }
                        className="button -blue-1 size-40 rounded-full border-light"
                      >
                        <i className="icon-chevron-right text-12"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* filter  */}
      {selectedItinerary && (
        <div className={`mapFilter ${isActiveMapFilter && "-is-active"}`}>
          <div
            className="mapFilter__overlay"
            onClick={() => setIsActiveMapFilter(false)}
          ></div>

          <div className="mapFilter__close">
            <button
              className="button -red-1 size-40 bg-white shadow-2"
              onClick={() => setIsActiveMapFilter(false)}
            >
              <i className="icon-close text-15"></i>
            </button>
          </div>

          <div
            className={`mapFilter__grid row d-flex justify-content-between px-0 py-0 ${
              isSmallScreen ? "mobile-layout" : ""
            }`}
            data-x="mapFilter__grid"
            data-x-toggle="-filters-hidden"
            style={
              isSmallScreen
                ? {
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }
                : {}
            }
          >
            {" "}
            <div
              className="mapFilter-filter scroll-bar-1 col-lg-8"
              style={{
                scrollbarWidth: "thin",
                scrollbarColor: `${brandColor} transparent`,
              }}
            >
              <div className="px-20 py-20 md:px-15 md:py-15">
                <h2 className="text-22 fw-500">
                  {/* Itinerary Map */}
                  {cruisesListBooking?.cruisesGeneralData?.durationFullName}
                  <br />
                </h2>
                <div className="mapFilter-filter__item">
                  <div className="row y-gap-20">
                    <div className="col-lg-12">
                      <div className="accordion -map row y-gap-20">
                        {selectedItinerary?.days?.map((itinerary, index) => (
                          <div className="col-12" key={index}>
                            <div
                              className={`accordion__item  ${
                                activeFaq === index ? "is-active" : ""
                              }`}
                            >
                              <div className="d-flex" key={itinerary.dayNumber}>
                                <div className="accordion__icon size-40 flex-center bg-blue-2 text-blue-1 rounded-full">
                                  <div className="text-14 fw-500 ">
                                    {itinerary.dayNumber}
                                  </div>
                                </div>

                                <div className="ml-30 w-100">
                                  <div className="text-16 lh-15 fw-500 text-blue-1">
                                    {itinerary.dayTitle}
                                  </div>
                                  {/* <div className="text-14 lh-15 text-light-1 mt-5">
                                     {itinerary.description}
                                   </div> */}

                                  {activeFaq === index && (
                                    <div
                                      className="accordion__content"
                                      style={{
                                        maxHeight: "100%",
                                        position: "relative",
                                      }}
                                    >
                                      <div className="d-flex justify-content-start align-items-center pt-15 pb-15">
                                        {/* <img
                                          src={itinerary.dayPhot}
                                          // src="https://staging.bookingnile.com/titsolutions/img/lists/tour/single/2.png"
                                          alt={itinerary.dayTitleName}
                                          className="rounded-4 mt-15"
                                        /> */}
                                        <div
                                          className="text-14 lh-17 ms-0 mt-15"
                                          dangerouslySetInnerHTML={{
                                            __html: itinerary.dayDetails,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}

                                  <div className="accordion__button">
                                    <button
                                      style={{
                                        margin: activeFaq === index && "auto",
                                      }}
                                      type="button"
                                      className="d-block lh-15 text-14     fw-500 mt-5"
                                      onClick={() => toggleAccordion(index)}
                                    >
                                      {activeFaq === index ? (
                                        <>
                                          <FontAwesomeIcon
                                            className="text-14 text-blue-1"
                                            icon={faAngleUp}
                                          />{" "}
                                          <br />
                                          <span className="text-14 text-blue-1">
                                            {t("common.showLess")}
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          <span className="text-14 text-secondary">
                                            {t("common.viewMore")}
                                          </span>{" "}
                                          <FontAwesomeIcon
                                            className="text-10 text-secondary"
                                            icon={faAngleDown}
                                          />
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <hr
                        style={{
                          borderTop: "1px solid #f5f5f5",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="mapFilter-map col-lg-4   p-0"
              style={
                isSmallScreen
                  ? {
                      position: "relative",
                      right: "auto",
                      top: "auto",
                      transform: "none",
                      width: "100%",
                      padding: "10px",
                    }
                  : {
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                    }
              }
            >
              <img
                alt={
                  cruisesListBooking?.cruise?.length > 0
                    ? cruisesListBooking?.itinaryNameSys
                    : ""
                }
                src={
                  cruisesListBooking?.cruise?.length > 0 &&
                  selectedItinerary?.itineraryPhoto
                    ? selectedItinerary?.itineraryPhoto
                    : "map-7days-NC.jpg"
                }
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ListingCruises;
